<template>
  <div>
    <v-select
      :value="value"
      dense
      solo
      flat
      hide-details
      outlined
      :items="list"
      item-text="text"
      item-value="value"
      @input="onInput"
    >
    </v-select>
  </div>
</template>

<script>
import { STATUS } from "@/constants";

const _ = require("lodash");
export default {
  props: ["value"],

  computed: {
    objNm() {
      return this.$route.params.objNm;
    },

    list() {
      const key = this.objNm.toUpperCase();
      if (_.isEmpty(STATUS[key])) {
        return [];
      }
      const list = Object.keys(STATUS[key]).map((k) => STATUS[key][k]);
      return [
        {
          value: null,
          text: "상태를 선택해주세요",
        },
        ...list,
      ];
    },
  },

  methods: {
    onInput(v) {
      this.$emit("input", v);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/fields/Status.vue